import Wavy from "./classes/wavy.ts";

const wavies = document.querySelectorAll("[data-wavy]");
wavies.forEach((wavy) => {
    new Wavy({
        rootElement: wavy as HTMLElement,
        width: parseInt(wavy.getAttribute("data-wavy-width")!),
        height: parseInt(wavy.getAttribute("data-wavy-height")!),
        imgSrc: wavy.getAttribute("data-wavy-img")!
    }).init();
});